"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const logo_svg_1 = tslib_1.__importDefault(require("./static/img/logo.svg"));
const StyledImage = styled_1.default(react_core_1.Image) `
  height: 56px;
`;
exports.Logo = (props) => (React.createElement(StyledImage, Object.assign({ src: logo_svg_1.default, alt: "NEO\u2022ONE" }, props)));

//# sourceMappingURL=Logo.js.map
